<template>
    <div class="main-buttons text-center text-primary pt-5 pb-5">
        <b-container class="px-4">
            <b-row>
                <b-col xl="8" v-if="room_selected">
                    <h2 class="text-secondary font-monospace text-uppercase">
                        {{this.room.text}}
                    </h2>
                </b-col>
                <b-col v-else-if="precentialRooms && precentialRooms.active ===1 && isLoggedIn && room_options.length > 0"  xl="8" class="mb-3">
                    <ComboSelect 
                        @selected="roomSelected" 
                        :data="{default_value: null, label: 'Seleccione el Salón', options: room_options}"
                    />
                </b-col>
            </b-row>
            <b-row class="gx-5 justify-content-center">
                <b-col xl="8" class="mb-3">
                    <b-button  
                        block 
                        pill 
                        variant="outline-primary" 
                        class="h3 pt-3 pb-2 text-uppercase shadow border-lg border-secondary" 
                        target="blank" 
                        href="/static/pdf/agenda.pdf"
                    >
                        Descarga Agenda
                    </b-button>
                </b-col>
                <b-col xl="8" class="mb-3">
                    <b-button  
                        v-if="!isLoggedIn" 
                        block 
                        pill 
                        variant="secondary" 
                        class="h3 pt-3 pb-2 text-uppercase shadow border-lg border-secondary" 
                        @click="$eventHub.$emit('showLogin')"
                    >
                        {{this.event.demo_mode?'Ingresar':this.event.finished?'Ingresar':'Registro'}}
                    </b-button>
                </b-col>
            </b-row>
            <b-row class="gx-5 justify-content-center" v-if="isLoggedIn">
                <b-col xl="8" class="mb-3" v-if="!$store.getters.chat_its_open && (room || (!precentialRooms && precentialRooms.active === 0))">
                    <b-button 
                        block 
                        variant="primary"
                        class="text-white pt-3 pb-3 btn-custom-rounded shadow-lg bordered" 
                        @click="$eventHub.$emit('showChat')">
                        Preguntar al ponente
                    </b-button>
                </b-col>
                <!-- <b-col xl="8" class="mb-3" v-if="$store.getters.event.survey_enabled && !$store.getters.already_answered">
                    <b-button 
                        block 
                        variant="secondary"
                        class="text-primary pt-3 pb-3 btn-custom-rounded shadow-lg bordered" 
                        @click="$eventHub.$emit('showSurvey')">
                        Contestar Encuesta
                    </b-button>
                </b-col> -->
                <b-col xl="8" class="mb-3" v-if="$store.getters.event.enable_exam ===1">
                    <h5>Para descargar su constancia del Aval: CMIM, CONAMEGE o COMEMEGE, AMMEGFAC es necesario aprobar el examen con al menos 13/15 aciertos.</h5>
                </b-col>
                <b-col xl="8" class="mb-3" v-if="$store.getters.event.enable_exam ===1">
                    <b-button 
                        block 
                        variant="secondary"
                        class="text-primary pt-3 pb-3 btn-custom-rounded shadow-lg bordered" 
                        @click="$eventHub.$emit('showExam')">
                        Contestar Examen
                    </b-button>
                </b-col>
                <b-col xl="8" class="mb-3" v-if="event.enable_diploma===1">
                    <h5>Una vez aprobado el examen, la constancia de Aval: COMEMEGE, AMMEGFAC se enviará posterior al evento al correo electrónico registrado.</h5>
                </b-col>
                <b-col xl="8" class="mb-3" v-if="$store.getters.event.enable_diploma">
                    <b-button 
                        v-if="isLoggedIn && event.enable_diploma===1"
                        block 
                        variant="info"
                        class="text-white pt-3 pb-3 btn-custom-rounded shadow-lg bordered" 
                        @click="$eventHub.$emit('showDiploma')">
                        Obtener Constancia
                    </b-button>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import Vue from 'vue'
import ComboSelect from '@/components/Widget/ComboSelect/ComboSelect.vue'

export default Vue.extend({
    name: 'MainButtons',
    data() {
        return {
            room_options: [],
            room_selected: false
        }
    },
    methods: {
        roomSelected(value) {
            let room= this.room_options.find((item) => item.value === value )
            if(room) {
                this.$store.commit('set_room', room)
            }
            this.room_selected = true
        },
    },
    components: {
        ComboSelect
    },
    computed: {
        isLoggedIn : function() {
            return this.$store.getters.isLoggedIn
        },
        event() { return this.$store.getters.event },
        room: function() { return this.$store.getters.room },
        precentialRoomsData: function() {
            if(this.precentialRooms) return JSON.parse(this.precentialRooms.params)
            return []
        },
        precentialRooms : function() { return this.$store.getters.getModule('PrecentialRooms') },
    },
    beforeCreate () {
        
    },
    created () {
        
    },
    mounted () {
        this.room_options = this.precentialRoomsData
    },
    watch: {
        precentialRooms(newValue, oldValue) {
            if(!newValue || newValue.active === 0) {
                this.room_selected = false
                this.$store.commit(
                    'set_room', 
                    { value: "general",text: "Salón General", room:"presencial-general"}
                )
            } else {
                this.room_options = this.precentialRoomsData
            }
        }
    },
})
</script>

<style lang="scss" scoped>
@import '../../../styles/app';

.main-buttons {
    .btn-custom-rounded {
        font-size: 22px;
        text-transform: uppercase;
        letter-spacing: 1.3px;
        font-weight: 700;
        border-radius: 500px;
        border-color: var(--primary);
        transition: all 0.3s ease-in-out 0s;
    }
}
</style>